import library from './modelPhotoLibrary.json';
import pralinLayers from './pralinLayers.json';
import { canonicalSlug } from './catalog';

export const MODEL_PHOTO_LIBRARY_VERSION = library.version;

export const photographicOnly = rawSlug =>
  canonicalSlug(rawSlug) === 'pralin-le-cornet' || library.models[canonicalSlug(rawSlug)]?.photographic_only === true;

export function exactModelPhoto({
  slug: rawSlug,
  front,
  back,
  view = 'front',
  thumbnail = false,
}) {
  const slug = canonicalSlug(rawSlug);
  if (['sylvette-la-crevette', 'pralin-le-cornet'].includes(slug)) return null;

  const model = library.models[slug];
  if (!model) return null;

  const optionId = view === 'back' ? back?.option_id || model.preview_back :
    front?.option_id || model.preview_front;
  if (!optionId) return null;

  const entry = model[view]?.[optionId];
  if (!entry?.src) return null;

  return {
    src: thumbnail && entry.thumb ? entry.thumb : entry.src,
    exact: true,
    optionId,
    slug,
    view,
    version: model.version || library.version,
  };
}

export function registeredPhotoCoverage(rawSlug) {
  const slug = canonicalSlug(rawSlug);
  if (slug === 'pralin-le-cornet') return {
    front:Object.keys(pralinLayers.front).length, back:Object.keys(pralinLayers.back).length,
  };
  const model = library.models[slug];
  if (!model) return { front: 0, back: 0 };
  return {
    front: Object.values(model.front || {}).filter(entry => entry?.src).length,
    back: Object.values(model.back || {}).filter(entry => entry?.src).length,
  };
}
